import {
  ColumnFilter,
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  FilterType,
  SelectOption,
  UserPermission
} from '@globaleris/ui.library'
import { Edit, Pageview } from '@material-ui/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { EnumClaseFactura, EnumIdioma, EnumTipoFactura } from '../../../api'
import { EnumSubTipoConfiguracion } from '../../../api/oData/enums/enumSubTipoConfiguracion'
import { EnumTipoConfiguracion } from '../../../api/oData/enums/enumTipoConfiguracion'
import { enumToSelectOptionArray } from '../../../helpers'
import { hasPermission } from '../../../helpers/permissionsHelper'
import { Resources } from '../../../model/RBAC/constants'
import {
  getCustomerDomain,
  storeDataTableFilterForCurrentPage,
  storeDataTableSearchForCurrentPage
} from '../../../redux'
import TemplateSettings from '../templateSettings.model'

interface TemplateSettingTableProps {
  data: TemplateSettings[] | undefined
  productsList: SelectOption[]
  templateType: EnumTipoConfiguracion
  contractTypeList: SelectOption[]
  // clientList: SelectOption[]
  addTemplateHandler: () => Promise<boolean>
  editTemplateHandler: (row: TemplateSettings) => void
  viewTemplateHandler: (row: TemplateSettings) => void
}
export const TemplateSettingsTable: React.FC<TemplateSettingTableProps> = ({
  data,
  productsList,
  templateType,
  contractTypeList,
  //clientList,
  addTemplateHandler,
  editTemplateHandler,
  viewTemplateHandler
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'templateSettings', 'enums'])
  const history = useHistory()
  const columns: DataTableColumn[] = [
    {
      name: 'id',
      display: false
    },
    {
      name: 'templateType',
      label: t('templateSettings:dataTable.templateType'),
      hideForResponsive: true,
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(EnumTipoConfiguracion, 'enums:EnumTipoConfiguracion'),
      readOnly: true
    },
    {
      name: 'templateSubType',
      label: t('templateSettings:dataTable.templateSubType'),
      hideForResponsive: true,
      display: templateType === EnumTipoConfiguracion.Widget,
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(
        EnumSubTipoConfiguracion,
        'enums:EnumSubTipoConfiguracion'
      )
    },
    {
      name: 'description',
      label: t('templateSettings:dataTable.description'),
      type: DataType.TEXT
    },
    {
      name: 'products',
      label: t('templateSettings:dataTable.products'),
      type: DataType.MULTISELECT,
      selectOptions: productsList
    },
    {
      name: 'contractType',
      label: t('templateSettings:dataTable.contractType'),
      type: DataType.MULTISELECT,
      selectOptions: contractTypeList
    },
    // {
    //   name: 'client',
    //   label: t('templateSettings:dataTable.client'),
    //   type: DataType.MULTISELECT,
    //   selectOptions: clientList
    // },
    {
      name: 'language',
      label: t('templateSettings:dataTable.language'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(EnumIdioma, 'enums:EnumIdioma')
    },
    {
      name: 'invoiceType',
      label: t('templateSettings:dataTable.invoiceType'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(EnumTipoFactura, 'enums:EnumTipoFactura')
    },
    {
      name: 'invoiceClass',
      label: t('templateSettings:dataTable.invoiceClass'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(EnumClaseFactura, 'enums:EnumClaseFactura')
    },
    {
      name: 'currentVersion',
      label: t('templateSettings:dataTable.currentVersion'),
      type: DataType.TEXT
    }
  ]
  const options: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: true,
    elevation: 1,
    filterType: FilterType.ADVANCED,
    download: false,
    print: false,
    selectableRows: false,
    canDelete: false,
    canEdit: false,
    fabLabel: t('templateSettings:dataTable.fab'),
    canInsert: hasPermission(Resources.TemplateSettings, [UserPermission.EDIT]),
    customInsertEditModal: true,
    onRowInsert: addTemplateHandler,
    onFilterChange: (filter: ColumnFilter[]) => {
      storeDataTableFilterForCurrentPage(filter)
    },
    onSearchChange: (search: string) => {
      storeDataTableSearchForCurrentPage(search)
    },
    analytics: {
      customer: getCustomerDomain(),
      view: t('templateSettings:dataTable.analytics')
    },
    rowCustomActions: [
      {
        userPermission: UserPermission.EDIT,
        icon: <Pageview fontSize="small" />,
        tooltip: t('templateSettings:dataTable.view'),
        onClick: viewTemplateHandler
      },
      {
        userPermission: UserPermission.EDIT,
        icon: <Edit fontSize="small" />,
        tooltip: t('templateSettings:dataTable.edit'),
        onClick: editTemplateHandler
      }
    ]
  }

  return <DataTable data={data} columns={columns} options={options} />
}
